import React from 'react';

const PositionTypeIndicator = ({ type }) => {
  const isLong = type === 'LONG';
  const displayText = isLong ? 'Long' : 'Short';

  return (
    <div className="ml-1.5">
      <div className={`
        px-2 py-0.5 rounded text-xs font-medium tracking-wide
        ${isLong ? 'bg-emerald-500/20 text-emerald-500' : 'bg-crimson-500/20 text-crimson-500'}
      `}>
        {displayText}
      </div>
    </div>
  );
};

export default PositionTypeIndicator;